export const rootClassName = "pageContainer";
export const historyPageSize = 15;
export const windowWidthThreshold = 2100;
